import { calcOpenEstActualsAttibute, getBackData, getDataRows, getPinnedBottomData, getRawFooter, prepareGridData } from "./rows"

export const getFooters = (props) => {
    const { rawButaneData, rawIsoButaneDta, rawNormalButaneData, rawPropaneData,
        rawCondensateData } = props

    const butaneFooterRaw = getRawFooter(rawButaneData)
    const isoButaneFooterRaw = getRawFooter(rawIsoButaneDta)
    const normalButaneFooterRaw = getRawFooter(rawNormalButaneData)
    const propaneFooterRaw = getRawFooter(rawPropaneData)
    const condensateFooterRaw = getRawFooter(rawCondensateData)

    return {
        butaneFooterRaw,
        isoButaneFooterRaw,
        normalButaneFooterRaw,
        propaneFooterRaw,
        condensateFooterRaw
    }
}

export const getOlds = (props) => {
    const { rawButaneData, rawIsoButaneDta, rawNormalButaneData, rawPropaneData,
        rawCondensateData } = props

    const butaneBackData = getBackData(rawButaneData)
    const isoButaneBackData = getBackData(rawIsoButaneDta)
    const normalButaneBackData = getBackData(rawNormalButaneData)
    const propaneBackData = getBackData(rawPropaneData)
    const condensateBackData = getBackData(rawCondensateData)

    return {
        butaneBackData,
        isoButaneBackData,
        normalButaneBackData,
        propaneBackData,
        condensateBackData
    }
}

export const getOpens = (props) => {
    const { superProps, butaneBackData, isoButaneBackData, normalButaneBackData,
        propaneBackData, condensateBackData, chkChng } = props

    const butaneOpen = calcOpenEstActualsAttibute(
        superProps, 'Butane', chkChng, butaneBackData)
    const isoButaneOpen = calcOpenEstActualsAttibute(
        superProps, 'Iso-Butane', chkChng, isoButaneBackData)
    const normalButaneOpen = calcOpenEstActualsAttibute(
        superProps, 'Normal Butane', chkChng, normalButaneBackData)
    const propaneOpen = calcOpenEstActualsAttibute(
        superProps, 'Propane', chkChng, propaneBackData)
    const condensateOpen = calcOpenEstActualsAttibute(
        superProps, 'Condensate', chkChng, condensateBackData)

    return {
        butaneOpen,
        isoButaneOpen,
        normalButaneOpen,
        propaneOpen,
        condensateOpen
    }
}

export const getRows = (props) => {
    const { rawButaneData, rawIsoButaneDta, rawNormalButaneData,
        rawPropaneData, rawCondensateData } = props

    const pData = getDataRows(rawPropaneData)
    const bData = getDataRows(rawButaneData)
    const isoBData = getDataRows(rawIsoButaneDta)
    const normalBData = getDataRows(rawNormalButaneData)
    const cData = getDataRows(rawCondensateData)

    return {
        pData,
        bData,
        isoBData,
        normalBData,
        cData
    }
}

export const getPinnedBottoms = async (props) => {
    const {
        superProps,
        generatePinnedBottomData,
        calculatePinnedBottomData,
        butaneGridOptions,
        isoButaneGridOptions,
        normalButaneGridOptions,
        propaneGridOptions,
        condensateGridOptions,
        footers,
        opens,
        rowsData
    } = props

    const {
        butaneFooterRaw,
        isoButaneFooterRaw,
        normalButaneFooterRaw,
        propaneFooterRaw,
        condensateFooterRaw
    } = footers

    const {
        butaneOpen,
        isoButaneOpen,
        normalButaneOpen,
        propaneOpen,
        condensateOpen
    } = opens

    const { bData, isoBData, normalBData, pData, cData } = rowsData

    const butanePinnedBottomData = await getPinnedBottomData({
        superProps,
        footerRaw: butaneFooterRaw,
        gridOptions: butaneGridOptions,
        opens: butaneOpen,
        customFacility: { value: 'Butane' },
        generatePinnedBottomData,
        calculatePinnedBottomData,
        rowData: bData
    })

    const isoButanePinnedBottomData = await getPinnedBottomData({
        superProps,
        footerRaw: isoButaneFooterRaw,
        gridOptions: isoButaneGridOptions,
        opens: isoButaneOpen,
        customFacility: { value: 'Iso-Butane' },
        generatePinnedBottomData,
        calculatePinnedBottomData,
        rowData: isoBData
    })

    const normalButanePinnedBottomData = await getPinnedBottomData({
        superProps,
        footerRaw: normalButaneFooterRaw,
        gridOptions: normalButaneGridOptions,
        opens: normalButaneOpen,
        customFacility: { value: 'Normal Butane' },
        generatePinnedBottomData,
        calculatePinnedBottomData,
        rowData: normalBData
    })
    const propanePinnedBottomData = await getPinnedBottomData({
        superProps,
        footerRaw: propaneFooterRaw,
        gridOptions: propaneGridOptions,
        opens: propaneOpen,
        customFacility: { value: 'Propane' },
        generatePinnedBottomData,
        calculatePinnedBottomData,
        rowData: pData
    })
    const condensatePinnedBottomData = await getPinnedBottomData({
        superProps,
        footerRaw: condensateFooterRaw,
        gridOptions: condensateGridOptions,
        opens: condensateOpen,
        customFacility: { value: 'Condensate' },
        generatePinnedBottomData,
        calculatePinnedBottomData,
        rowData: cData
    })

    return {
        butanePinnedBottomData,
        isoButanePinnedBottomData,
        normalButanePinnedBottomData,
        propanePinnedBottomData,
        condensatePinnedBottomData
    }
}

export const getHiddenGridsData = (props) => {
    const { selectedMonth, overUnderViewON, nominationRole, selectedUOM, footers,
        opens, rowsData } = props

    const { butaneFooterRaw, isoButaneFooterRaw, normalButaneFooterRaw,
        propaneFooterRaw, condensateFooterRaw } = footers

    const { butaneOpen, isoButaneOpen, normalButaneOpen, propaneOpen,
        condensateOpen } = opens

    const { bData, isoBData, normalBData, pData, cData } = rowsData

    const butane = prepareGridData({
        overUnderViewON,
        openEst: butaneOpen.openEst,
        openAct: butaneOpen.openAct,
        selectedMonth,
        data: bData,
        adjustUnit: butaneFooterRaw?.unit || 0,
        nominationRole,
        selectedUOM
    })
    const isoButane = prepareGridData({
        overUnderViewON,
        openEst: isoButaneOpen.openEst,
        openAct: isoButaneOpen.openAct,
        selectedMonth,
        data: isoBData,
        adjustUnit: isoButaneFooterRaw?.unit || 0,
        nominationRole,
        selectedUOM
    })
    const normalButane = prepareGridData({
        overUnderViewON,
        openEst: normalButaneOpen.openEst,
        openAct: normalButaneOpen.openAct,
        selectedMonth,
        data: normalBData,
        adjustUnit: normalButaneFooterRaw?.unit || 0,
        nominationRole,
        selectedUOM
    })
    const propane = prepareGridData({
        overUnderViewON,
        openEst: propaneOpen.openEst,
        openAct: propaneOpen.openAct,
        selectedMonth,
        data: pData,
        adjustUnit: propaneFooterRaw?.unit || 0,
        nominationRole,
        selectedUOM
    })
    const condensate = prepareGridData({
        overUnderViewON,
        openEst: condensateOpen.openEst,
        openAct: condensateOpen.openAct,
        selectedMonth,
        data: cData,
        adjustUnit: condensateFooterRaw?.unit || 0,
        nominationRole,
        selectedUOM
    })

    return { butane, isoButane, normalButane, propane, condensate }
}